import ge from './ge.json';
import en from './en.json';


export const dictionaryList = { en, ge };
export const languageOptions = {
  en: 'English',
  ge: 'German'
};